import { useDrag as useDndDrag } from "react-dnd";

interface UseDragProps {
  id: string;
  index: number;
  moveType: string;
}

export default function useDrag({ id, index, moveType }: UseDragProps) {
  const [{ isDragging }, drag] = useDndDrag({
    type: moveType,
    item: () => {
      return { id, index };
    },
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return { isDragging, drag };
}
